var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor string-formatter" },
    [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.stringFormatterFormat"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.formatTypes,
              idKey: "id",
              labelKey: "label",
              title: "Select Format",
            },
            model: {
              value: _vm.clone.mode,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "mode", $$v)
              },
              expression: "clone.mode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize data-items" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.stringFormatterInputText"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Input Text",
              "show-attributes": true,
              "show-emoji": false,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "value", $$v)
              },
              expression: "clone.value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.mode === "string.default"
        ? _c("StringFormatterDefault", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.jsonpath"
        ? _c("StringFormatterJsonPath", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.split"
        ? _c("StringFormatterSplit", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.replace"
        ? _c("StringFormatterReplace", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.truncate"
        ? _c("StringFormatterTruncate", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.trim"
        ? _c("StringFormatterTrim", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.regex"
        ? _c("StringFormatterRegex", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.find"
        ? _c("StringFormatterFind", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.word_count"
        ? _c("StringFormatterWordCount", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "string.extract_phone_number"
        ? _c("StringFormatterExtractPhoneNumber", {
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }